import { useEffect, useState } from 'react';
import { PageContainer, PageTitle, Button, Table, ErrorText } from '../../ui';
import {
  getExportHistory,
  generateFec,
  generateSaft,
} from "../../services/accountingApi";

export default function ExportsPage() {
  const [history, setHistory] = useState([]);
  const [error, setError] = useState(null);

  const fetchHistory = async () => {
    try {
      const data = await getExportHistory();
      setHistory(data || []);
    } catch (err) {
      setError(err.response?.data?.error || 'Erreur lors du chargement de l\'historique.');
    }
  };

  useEffect(() => {
    fetchHistory();
  }, []);

  const handleFec = () => generateFec();
  const handleSaft = () => generateSaft();

  return (
    <PageContainer>
      <PageTitle>Exports</PageTitle>
      <div style={{ marginBottom: '1rem' }}>
        <Button onClick={handleFec}>Exporter FEC</Button>
        <Button onClick={handleSaft} style={{ marginLeft: '0.5rem' }}>Exporter SAF-T</Button>
      </div>
      {error && <ErrorText>{error}</ErrorText>}
      <Table>
        <thead>
          <tr>
            <th>Fichier</th>
            <th>Hash</th>
            <th>Date</th>
          </tr>
        </thead>
        <tbody>
          {history.map((h, idx) => (
            <tr key={idx}>
              <td>{h.filename}</td>
              <td>{h.sha256}</td>
              <td>{h.timestamp}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </PageContainer>
  );
}